import React, { ReactElement } from 'react';
import { LoaderWrapper, LoaderWrapperProps } from '../LoaderWrapper';

type LoaderDotsColours =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'success'
  | 'info'
  | 'warning'
  | 'warning-alt'
  | 'danger'
  | 'dark'
  | 'light';

export interface LoaderDotsProps
  extends Omit<LoaderWrapperProps, 'dots' | 'className' | 'children'> {
  colour?: LoaderDotsColours;
}

export function LoaderDots({
  colour = 'primary',
  ...rest
}: LoaderDotsProps): ReactElement {
  const classes = `loading-dots loading-dots--${colour}`;

  return (
    <LoaderWrapper {...rest} className={classes}>
      <span></span>
      <span></span>
      <span></span>
    </LoaderWrapper>
  );
}
